import { Box, Button, Stack, styled } from '@mui/material';

export const StyledStack = styled(Stack)`
  border: 1px solid #c0c7ca;
  position: relative;
  border-radius: 8px;
  height: 40px;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  font-family: 'Open Sans', sans-serif;

  &:focus-within {
    border: 2px solid ${(props) => props.theme.palette.primary.main};
  }

  & .MuiInputBase-root {
    font-family: inherit;
    padding: 16px;
    flex: 1;
  }
`;

export const StyledSubmitButton = styled(Button)`
  height: inherit;
  padding: 11px;
  border-radius: 0 8px 8px 0;
  margin-right: -1px;
`;
export const StyledClearButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  font-size: 24px;
  border: none;
  min-width: 32px;
  padding: 0;
  cursor: pointer;
  border-radius: 8px;
  color: #3c3445;
  pointer-events: all;
`;

export const StyledHistoryDropdown = styled(Box)`
  z-index: 1;
  position: absolute;
  top: 48px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 500px;
  width: auto;
  overflow-y: hidden;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  & > div {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }
  }

  & span {
    flex: 1;
  }
`;
export const StyledContainer = styled(Stack)`
  flex-direction: row;
`;
